export default function BottomText(props) {
    return (
        <input type="text" name="bottomText" onChange={props.handleChange} className="bottom-text" placeholder="bottom of meme"></input>
    )
}